import React from "react";
import { RD_GREEN, RD_GREEN_SOFT, STEPS } from "./constants";

// แถบขั้นตอนหน้าตาเดียวกับแบบ ภ.ง.ด.90/91 บนเว็บ e-Filing
// ข้อมูลบันทึกอัตโนมัติทุกขั้น จึงกดสลับไปขั้นไหนก็ได้ ไม่ต้องไล่ตามลำดับ
export default function TaxStepper({ step, onSelect }) {
  return (
    <div className="rounded-4 py-4 px-3 mb-4" style={{ background: RD_GREEN_SOFT }}>
      <div className="d-flex justify-content-center align-items-start" style={{ overflowX: "auto" }}>
        {STEPS.map((item, index) => {
          const done = item.value <= step;
          return (
            <React.Fragment key={item.value}>
              {index > 0 && (
                <div
                  className="flex-grow-1 mt-3"
                  style={{ height: 2, background: item.value <= step ? RD_GREEN : "#d6e4d8", minWidth: 24, maxWidth: 120 }}
                />
              )}
              <div className="text-center px-2" style={{ minWidth: 110, cursor: "pointer" }} onClick={() => onSelect(item.value)}>
                <div
                  className="mx-auto d-flex align-items-center justify-content-center fw-semibold"
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: "50%",
                    background: done ? RD_GREEN : "#ffffff",
                    color: done ? "#ffffff" : "#9bb0a0",
                    border: `2px solid ${done ? RD_GREEN : "#d6e4d8"}`,
                  }}
                >
                  {item.value}
                </div>
                <div className="small mt-2" style={{ color: done ? "#2e7d32" : "#9bb0a0", fontWeight: item.value === step ? 600 : 400 }}>
                  {item.label}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
